import { useCallback, useMemo } from 'react';
import {
  useMentions as useDesignSystemMentions,
  type ChatMentionsMenuItemType,
} from '@terra/ui-design-system';
import { useLayoutStore } from '../store/layoutStore';

export function openCopilotPanel(): void {
  const { setSidePanelsVisible, setRightPanelView, setChatCollapsed } =
    useLayoutStore.getState();
  setSidePanelsVisible(true);
  setRightPanelView('copilot');
  setChatCollapsed(false);
}

export function useMentions() {
  const mentions = useDesignSystemMentions();

  const addMention = useCallback(
    (mention: ChatMentionsMenuItemType) => {
      openCopilotPanel();
      mentions.addMention(mention);
    },
    [mentions],
  );

  return useMemo(
    () => ({
      ...mentions,
      addMention,
    }),
    [mentions, addMention],
  );
}
